module.exports = __webpack_public_path__ + "img/logoInteliteAICheff.498c45ca.png";